import React, { useEffect } from 'react';
import { get } from 'lodash';
import styled from 'styled-components';
import { HOTEL_LIST_BANNER_EXPLORE } from './constants';

/**
 * Возвращает безопасно объект для работы с adfox
 * @typedef {object} Adfox
 * @property {*} createAdaptive
 * @property {*} destroy
 * @returns {(Adfox|undefined)}
 */
const getAdfoxScript = (): any => {
  const { Ya: { adfoxCode } = {} } = window;
  return adfoxCode;
};

export const bannerLoadable = (type: string) => {
  if (type === HOTEL_LIST_BANNER_EXPLORE) {
    return true;
  }

  const defaultValue = true;
  const showSlot = get(window, 'dataLayer.adfox_slot.show_slot', defaultValue);

  if (!showSlot || !getAdfoxScript()) {
    return false;
  }

  return true;
};

const initBanner = (params: any, ownerId: number, containerId: string) => {
  const adfoxCode = getAdfoxScript();

  if (!adfoxCode) return;

  adfoxCode.createAdaptive(
    {
      params,
      ownerId,
      containerId,
    },
    ['desktop', 'tablet', 'phone'],
    {
      tabletWidth: 960,
      phoneWidth: 694,
    },
  );
};

const destroyBanner = (containerId: string) => {
  const adfoxCode = getAdfoxScript();

  if (!adfoxCode) return;

  adfoxCode.destroy(containerId);
};

interface IAdfoxBanner {
  ownerId: number;
  containerId: string;
  params: any;
  className?: string;
  type: string;
}

export const AdfoxBanner: React.FC<IAdfoxBanner> = ({
  ownerId,
  containerId,
  params,
  className = '',
  type,
}) => {
  /* Assume that useEffect doesn't executed on SSR */
  /* On SSR  only render container. Banner content will be rendered clientsite */
  useEffect(() => {
    const canLoadBanner = bannerLoadable(type);

    if (!canLoadBanner) return () => null;

    initBanner(params, ownerId, containerId);

    return () => destroyBanner(containerId);
  }, [params, ownerId, containerId, type]);

  return <StyledContainer id={containerId} className={className} />;
};

const StyledContainer = styled.div`
  width: inherit !important;
  overflow: hidden;
`;
